import { alpha } from '@mui/material';

const GRADIENT_PRIMARY = 'linear-gradient(135deg, hsl(245 75% 58%), hsl(262 83% 66%))';

export type Tone = 'success' | 'warning' | 'neutral';

export const dialogBackdropSx = {
  backgroundColor: 'rgba(23, 26, 36, 0.4)',
  backdropFilter: 'blur(2px)',
};
export const dialogPaperSx = { borderRadius: 3, overflow: 'hidden' };
export const headerSx = { px: 2.5, py: 2, borderBottom: '1px solid', borderColor: 'divider' };
export const iconTileBaseSx = {
  width: 34,
  height: 34,
  borderRadius: '10px',
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  '& svg': { fontSize: 18 },
};
export const headerTextSx = { flex: 1, minWidth: 0 };
export const titleSx = { fontSize: 14, fontWeight: 600, letterSpacing: '-0.01em' };
export const subtitleSx = { fontSize: 11.5, color: 'text.secondary' };
export const closeHeaderButtonSx = { color: 'text.secondary' };
export const closeHeaderIconSx = { fontSize: 18 };
export const dialogContentSx = { p: 0 };
export const progressWrapSx = { px: 2.5, pt: 2 };
export const progressRailSx = {
  display: 'flex',
  height: 6,
  borderRadius: 99,
  overflow: 'hidden',
  bgcolor: 'grey.100',
};
export const skippedRailSx = { width: '100%', bgcolor: 'grey.400' };
export const successRailSx = { bgcolor: 'success.main', transition: 'width 250ms ease' };
export const failedRailSx = { bgcolor: 'error.main', transition: 'width 250ms ease' };
export const logContainerSx = { maxHeight: 260, overflowY: 'auto', px: 1.5, py: 1.5 };
export const logRowSx = {
  px: 1,
  py: 0.75,
  borderRadius: 1.5,
  '&:hover': { bgcolor: 'action.hover' },
};
export const logNameSx = { flex: 1, minWidth: 0, fontWeight: 500 };
export const logReasonSx = { flexShrink: 1, minWidth: 0 };
export const emptyLogSx = { color: 'text.secondary', px: 1, py: 1 };
export const footerSx = { px: 2.5, py: 1.75, borderTop: '1px solid', borderColor: 'divider' };
export const doneButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 2,
  background: GRADIENT_PRIMARY,
  '&:hover': { background: GRADIENT_PRIMARY, filter: 'brightness(1.05)' },
};
export const stopButtonSx = { textTransform: 'none', fontWeight: 600, borderRadius: 2 };
export const spinnerSx = { color: 'inherit' };
export const skippedIconSx = { fontSize: 18, color: 'text.disabled', flexShrink: 0 };

export const toneStyles = (tone: Tone) => {
  if (tone === 'success') {
    return { bg: (t: any) => alpha(t.palette.success.main, 0.12), color: 'success.main' };
  }
  if (tone === 'warning') {
    return { bg: (t: any) => alpha(t.palette.warning.main, 0.14), color: 'warning.main' };
  }
  return { bg: 'grey.100', color: 'text.primary' };
};

export const resultIconSx = (outcome: 'ok' | 'failed') => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  bgcolor: (t) => alpha(outcome === 'ok' ? t.palette.success.main : t.palette.error.main, 0.15),
  color: outcome === 'ok' ? 'success.main' : 'error.main',
});
